module.exports = __webpack_public_path__ + "img/drop.f908b8bb.svg";